import $ from 'jquery';
import 'what-input';
import Swiper from 'swiper';
var imagesLoaded = require('imagesloaded');
var Packery = require('packery');

// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
// require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';
import { Foundation } from 'foundation-sites/js/foundation.core';


$(document).foundation();

$(function(){
  
  // Off canvas click
  $('#main-nav a').on('click', function(){
    $('#main-nav').foundation('close');
  });

  // Reveal videos
  let playVideo = function($el) {
    $('.play', $el.closest('.swiper-slide')).addClass('is-hidden');
    $el[0].play();
  }

  let pauseVideo = function($el) {
    $('.play', $el.closest('.swiper-slide')).removeClass('is-hidden');
    $el[0].pause();
  }
  
  $('.reveal--creator .play').on('click', function(){
    playVideo($('video', $(this).parent()));
  });

  $('.reveal--creator video').on('click', function(){
    pauseVideo($(this));
  });

  let creatorGallery;
  $(document).on('open.zf.reveal', function (e) {
    let $el = $(e.target);
    if ($el.hasClass('reveal--creator')) {
      let $gallery = $el.find('.swiper-container');
      
      creatorGallery = new Swiper($gallery, {
        centeredSlides: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        on: {
          slideChange: function() {
            e.target.querySelectorAll('video').forEach(function(video){
              pauseVideo($(video));
            });
          }
        }
      });
    }
  });

  $(document).on('closed.zf.reveal', function (e) {
    var $el = $(e.target);
    if ($el.hasClass('reveal--creator')) {
      creatorGallery.destroy();
    }

    e.target.querySelectorAll('video').forEach(function (video) {
      pauseVideo($(video));
    });
  });
  
});


/**
 * Swiper
 */

// Hero
let heroSwiper = new Swiper('.hero .swiper-container', {
  parallax: true,
  speed: 500,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true
  },
});

// Clients
let clientsSwiper = new Swiper('.clients .swiper-container', {
  slidesPerView: 2,
  spaceBetween: 5,
  autoplay:true,
  breakpoints: {
    640: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 5,
    }
  },
  navigation: {
    nextEl: '.clients .swiper-button-next',
    prevEl: '.clients .swiper-button-prev',
  },
});

// Outsourcing
let outsourcingSwiper = new Swiper('.outsourcing .swiper-container', {
  slidesPerView: 3,
  spaceBetween: 20,
  breakpoints: {
    640: {
      slidesPerView: 4,
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 100,
    }
  },
  navigation: {
    nextEl: '.outsourcing .swiper-button-next',
    prevEl: '.outsourcing .swiper-button-prev',
  },
});

// Testimonials
let testimonialsSwiper = new Swiper('.testimonials .swiper-container', {
  slidesPerView: 3,
  spaceBetween: 30,
  navigation: {
    nextEl: '.testimonials_control__button-next',
    prevEl: '.testimonials_control__button-prev',
  },
  centeredSlides: true,
  breakpoints: {
    0: {
      slidesPerView: 1.1,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 100,
    }
  },
});


/**
 * Packery
 */

//  Creators
let creatorsGrid = document.querySelectorAll('.creators__list');
creatorsGrid.forEach((el) => {
  var packerys = el.querySelectorAll('.creators__list__item');
  if (packerys.length == 2 || packerys.length == 4){
    packerys.forEach((item) => {
      item.classList.add('creators__list__item-big');
    })
  }
  var creatorsPackery = new Packery(el, {
    itemSelector: '.creators__list__item',
    gutter: 10
  });

  new imagesLoaded(el).on('progress', function () {
    creatorsPackery.layout();
  });
})


/**
 * File upload
 */

let inputFiles = document.querySelectorAll('input[type=file]');
inputFiles.forEach((input) => {
  input.addEventListener('change', function(){
    processSelectedFiles(this);
  });
});

function processSelectedFiles(fileInput) {
  var files = fileInput.files;
  var fileName = fileInput.closest('.file-upload').querySelector('.media-kit-filename');

  for (var i = 0;i < files.length;i++) {
    if(i == 0) {
      fileName.innerHTML = files[i].name;
    } else {
      fileName.innerHTML += ' ' + files[i].name;
    }
  }
}


/**
 * Intersection Observer
 */
let windowHeight = window.innerHeight;
let observerThreshold = windowHeight >= 600 ? .50 : .3;

function startObserve() {
  const observer = new IntersectionObserver(
    intersectionCallback,
    { threshold: [0, observerThreshold] }
  )

  const targets = document.querySelectorAll('.step');
  targets.forEach((target) => {
    observer.observe(target);
  });
}

function intersectionCallback(entries) {
  entries.forEach(entry => {
    // console.log(entry.intersectionRatio);
    if (entry.intersectionRatio > observerThreshold) {
      entry.target.classList.add('is-active');
    }
  });
}

window.onload = () => {
  startObserve();
}

// TESTIMONIALS HOVER PLAY
// var testimonialList = document.querySelectorAll('.testimonials__list__item');
// var testimonialOverlay = document.querySelector('.testimonials_overlay');
// var testimonialVideo = testimonialOverlay.querySelector('.testimonials_overlay__video');

// function openTestimonialOverlay(){
//   testimonialOverlay.classList.add('testimonials_overlay-open');
// }
// function closeTestimonialOverlay(){
//   testimonialOverlay.classList.remove('testimonials_overlay-open');
// }
// function playVideoTestimonial(){
//   testimonialVideo.play();
// }
// function pauseVideoTestimonial(){
//   testimonialVideo.pause();
// }
// function setVideoOverlaySrc(object){
//   testimonialVideo.src=object.src
// }

// testimonialOverlay.addEventListener('click',function(e){''
//   if (e.target.className == 'testimonials_overlay testimonials_overlay-open'){
//     pauseVideoTestimonial();
//     closeTestimonialOverlay();
//   }
// })

// testimonialList.forEach(testimonial => {
//   // console.log(testimonialVideo.src);
//   testimonial.addEventListener('click',function(){
//     var video = testimonial.querySelector('.testimonials__list__item___content-video');

//     openTestimonialOverlay();
//     setVideoOverlaySrc(video);
//     playVideoTestimonial();
    
    
    
//   });
// });